var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 217.67,
    height: 145.09,
    viewBox: "0 0 217.67 145.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3014",
    "data-name": "Rectangle 3014",
    width: 217.67,
    height: 145.09,
    transform: "translate(0 -24)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2611",
    "data-name": "Rectangle 2611",
    width: 217.67,
    height: 121.09,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M262.955,105.441h20.51a10.255,10.255,0,0,0-20.51,0",
    transform: "translate(-262.955 -95.187)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M128.348,70.96c-.677-.006-1.347-.006-2.01-.006-1.628,0-3.25.046-4.857.148-21.2.7-46.781,4.267-60.847,16.39H196.061C181.994,75.368,156.407,71.8,135.207,71.1c-1.608-.1-3.223-.148-4.856-.148-.657,0-1.333,0-2,.006",
    transform: "translate(-60.635 -70.954)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M17.63,105.441H38.14a10.255,10.255,0,0,0-20.51,0",
    transform: "translate(-17.63 -95.187)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3010",
    "data-name": "Rectangle 3010",
    width: 20.579,
    height: 47.858,
    rx: 5.478,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3011",
    "data-name": "Rectangle 3011",
    width: 3.077,
    height: 3.077,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3012",
    "data-name": "Rectangle 3012",
    width: 1.859,
    height: 1.859,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2486",
    x: 75.675,
    y: -2.097,
    width: 67.028,
    height: 58.459,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#e64b4b",
    floodOpacity: 0.396
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4174",
    "data-name": "Group 4174",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4173",
    "data-name": "Group 4173",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M240.367,83.615H210.149a2.812,2.812,0,1,1,0-5.623h30.218a2.812,2.812,0,0,1,0,5.623",
    transform: "translate(-61.598 -23.171)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2610",
    "data-name": "Rectangle 2610",
    width: 5.623,
    height: 24.539,
    transform: "translate(191.828 47.083)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M262.955,105.441h20.51a10.255,10.255,0,0,0-20.51,0",
    transform: "translate(-78.121 -28.279)",
    fill: "#dae4f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4152",
    "data-name": "Group 4152",
    transform: "translate(184.834 66.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4151",
    "data-name": "Group 4151",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2612",
    "data-name": "Rectangle 2612",
    width: 20.51,
    height: 0.048,
    transform: "translate(0 10.206)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2613",
    "data-name": "Rectangle 2613",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 10.109)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2614",
    "data-name": "Rectangle 2614",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 10.013)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2615",
    "data-name": "Rectangle 2615",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.916)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2616",
    "data-name": "Rectangle 2616",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.819)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2617",
    "data-name": "Rectangle 2617",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.722)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2618",
    "data-name": "Rectangle 2618",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.626)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2619",
    "data-name": "Rectangle 2619",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.529)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2620",
    "data-name": "Rectangle 2620",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.432)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2621",
    "data-name": "Rectangle 2621",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.335)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2622",
    "data-name": "Rectangle 2622",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.238)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2623",
    "data-name": "Rectangle 2623",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.141)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2624",
    "data-name": "Rectangle 2624",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.045)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2625",
    "data-name": "Rectangle 2625",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.948)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2626",
    "data-name": "Rectangle 2626",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.851)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2627",
    "data-name": "Rectangle 2627",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.755)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2628",
    "data-name": "Rectangle 2628",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.658)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2629",
    "data-name": "Rectangle 2629",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.561)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2630",
    "data-name": "Rectangle 2630",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.464)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2631",
    "data-name": "Rectangle 2631",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.367)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2632",
    "data-name": "Rectangle 2632",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.27)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2633",
    "data-name": "Rectangle 2633",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.173)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.077)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2635",
    "data-name": "Rectangle 2635",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.98)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2636",
    "data-name": "Rectangle 2636",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.883)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2637",
    "data-name": "Rectangle 2637",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.787)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2638",
    "data-name": "Rectangle 2638",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.69)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2639",
    "data-name": "Rectangle 2639",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.593)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2640",
    "data-name": "Rectangle 2640",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.496)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2641",
    "data-name": "Rectangle 2641",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.4)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642",
    "data-name": "Rectangle 2642",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.303)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.206)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644",
    "data-name": "Rectangle 2644",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.109)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645",
    "data-name": "Rectangle 2645",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.012)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2646",
    "data-name": "Rectangle 2646",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.915)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2647",
    "data-name": "Rectangle 2647",
    width: 20.51,
    height: 0.098,
    transform: "translate(0 6.818)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2648",
    "data-name": "Rectangle 2648",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.721)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2649",
    "data-name": "Rectangle 2649",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.624)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2650",
    "data-name": "Rectangle 2650",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.528)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2651",
    "data-name": "Rectangle 2651",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.431)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2652",
    "data-name": "Rectangle 2652",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.334)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2653",
    "data-name": "Rectangle 2653",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.237)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2654",
    "data-name": "Rectangle 2654",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.141)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2655",
    "data-name": "Rectangle 2655",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.044)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2656",
    "data-name": "Rectangle 2656",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.947)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2657",
    "data-name": "Rectangle 2657",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.85)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2658",
    "data-name": "Rectangle 2658",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.753)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2659",
    "data-name": "Rectangle 2659",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.656)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2660",
    "data-name": "Rectangle 2660",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.56)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2661",
    "data-name": "Rectangle 2661",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.463)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2662",
    "data-name": "Rectangle 2662",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.366)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2663",
    "data-name": "Rectangle 2663",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.269)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2664",
    "data-name": "Rectangle 2664",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.173)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2665",
    "data-name": "Rectangle 2665",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.076)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2666",
    "data-name": "Rectangle 2666",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.979)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2667",
    "data-name": "Rectangle 2667",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.882)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2668",
    "data-name": "Rectangle 2668",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.785)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.688)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2670",
    "data-name": "Rectangle 2670",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.592)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2671",
    "data-name": "Rectangle 2671",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.495)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2672",
    "data-name": "Rectangle 2672",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.398)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2673",
    "data-name": "Rectangle 2673",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.302)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2674",
    "data-name": "Rectangle 2674",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.205)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2675",
    "data-name": "Rectangle 2675",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.108)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2676",
    "data-name": "Rectangle 2676",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.011)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677",
    "data-name": "Rectangle 2677",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.915)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2678",
    "data-name": "Rectangle 2678",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.818)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2679",
    "data-name": "Rectangle 2679",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.721)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2680",
    "data-name": "Rectangle 2680",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.624)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2681",
    "data-name": "Rectangle 2681",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.527)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2682",
    "data-name": "Rectangle 2682",
    width: 20.51,
    height: 3.528,
    transform: "translate(0 -0.001)",
    fill: "#dae4f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4154",
    "data-name": "Group 4154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4153",
    "data-name": "Group 4153",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M295.936,68.606H275.717a2.812,2.812,0,0,1,0-5.623h20.219a2.812,2.812,0,1,1,0,5.623",
    transform: "translate(-81.077 -18.712)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M259.278,68.606H247.384a2.812,2.812,0,1,1,0-5.623h11.894a2.812,2.812,0,1,1,0,5.623",
    transform: "translate(-72.66 -18.712)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M161.871,70.364a13.436,13.436,0,1,1-13.437-13.436,13.436,13.436,0,0,1,13.437,13.436",
    transform: "translate(-40.107 -16.913)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M165.754,76.336S160.267,63.8,149.466,63.8H136.517c-10.8,0-16.289,12.539-16.289,12.539s-4.595,15.055-1.32,29.2,17.772,14.85,17.772,14.85H149.3s14.5-.7,17.772-14.85-1.321-29.2-1.321-29.2",
    transform: "translate(-34.977 -18.953)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M175.474,113.658a69.961,69.961,0,0,1-1.648,12.124c-.006.027-.013.053-.02.08-4.943,21.141-26.639,22.192-26.639,22.192H128.231S106.543,147,101.593,125.862l-.021-.08a69.889,69.889,0,0,1-1.647-12.124Z",
    transform: "translate(-29.687 -33.767)",
    fill: "#cbe6ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2683",
    "data-name": "Rectangle 2683",
    width: 5.623,
    height: 18.338,
    transform: "translate(52.431 57.135)",
    fill: "#fdcf62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M84.465,83.615H54.247a2.812,2.812,0,1,1,0-5.623H84.465a2.812,2.812,0,1,1,0,5.623",
    transform: "translate(-15.281 -23.171)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M198.254,116.941H55.213c1.179-1.929,2.451-3.791,3.778-5.606-1.648-5.043-5.372-11.293-3.015-13.892a33.566,33.566,0,0,1,3.048-2.961H194.45a33.565,33.565,0,0,1,3.048,2.961c2.357,2.6-1.373,8.848-3.015,13.892,1.326,1.815,2.592,3.678,3.771,5.606",
    transform: "translate(-16.403 -28.07)",
    fill: "#cbe6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M196.061,87.491H60.635C74.7,75.368,100.282,71.8,121.482,71.1c1.608-.1,3.229-.148,4.857-.148.663,0,1.333,0,2.01.006s1.346-.006,2-.006c1.634,0,3.249.046,4.856.148,21.2.7,46.787,4.266,60.854,16.39",
    transform: "translate(-18.014 -21.08)",
    fill: "#7e9dae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4156",
    "data-name": "Group 4156",
    transform: "translate(42.621 49.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4155",
    "data-name": "Group 4155",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    width: 135.426,
    height: 0.153,
    transform: "translate(0)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 0.153)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 0.373)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 0.591)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 0.811)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 1.03)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 1.25)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 1.468)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 1.688)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 1.908)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 2.127)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 2.346)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 2.566)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 2.785)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 3.004)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 3.224)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 3.443)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 3.662)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 3.882)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 4.101)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 4.321)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 4.54)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2707",
    "data-name": "Rectangle 2707",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 4.759)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2708",
    "data-name": "Rectangle 2708",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 4.979)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2709",
    "data-name": "Rectangle 2709",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 5.198)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2710",
    "data-name": "Rectangle 2710",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 5.417)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2711",
    "data-name": "Rectangle 2711",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 5.637)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2712",
    "data-name": "Rectangle 2712",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 5.857)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2713",
    "data-name": "Rectangle 2713",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 6.075)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2714",
    "data-name": "Rectangle 2714",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 6.295)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2715",
    "data-name": "Rectangle 2715",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 6.514)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2716",
    "data-name": "Rectangle 2716",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 6.734)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2717",
    "data-name": "Rectangle 2717",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 6.952)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2718",
    "data-name": "Rectangle 2718",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 7.172)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2719",
    "data-name": "Rectangle 2719",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 7.391)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2720",
    "data-name": "Rectangle 2720",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 7.611)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2721",
    "data-name": "Rectangle 2721",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 7.83)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2722",
    "data-name": "Rectangle 2722",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 8.05)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2723",
    "data-name": "Rectangle 2723",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 8.269)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2724",
    "data-name": "Rectangle 2724",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 8.488)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2725",
    "data-name": "Rectangle 2725",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 8.708)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2726",
    "data-name": "Rectangle 2726",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 8.927)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2727",
    "data-name": "Rectangle 2727",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 9.146)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2728",
    "data-name": "Rectangle 2728",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 9.366)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2729",
    "data-name": "Rectangle 2729",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 9.585)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2730",
    "data-name": "Rectangle 2730",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 9.805)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2731",
    "data-name": "Rectangle 2731",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 10.023)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2732",
    "data-name": "Rectangle 2732",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 10.244)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2733",
    "data-name": "Rectangle 2733",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 10.462)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2734",
    "data-name": "Rectangle 2734",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 10.682)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 10.901)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 11.121)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 11.34)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 11.559)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2739",
    "data-name": "Rectangle 2739",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 11.779)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2740",
    "data-name": "Rectangle 2740",
    width: 135.426,
    height: 0.219,
    transform: "translate(0 11.998)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2741",
    "data-name": "Rectangle 2741",
    width: 135.426,
    height: 4.32,
    transform: "translate(0 12.217)",
    fill: "#7e9dae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4158",
    "data-name": "Group 4158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4157",
    "data-name": "Group 4157",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M86.27,122.381,59.51,149.14a3.211,3.211,0,0,1-2.278.945,2.908,2.908,0,0,1-.649-.067,3.221,3.221,0,0,1-1.863-5.211.713.713,0,0,1,.067-.074l.295-.295a.709.709,0,0,1,.073-.067L65.224,134.3l.039-.034a5.454,5.454,0,0,0-3.128-9.458,5.529,5.529,0,0,0-2.27.261l-1.614-2.686Z",
    transform: "translate(-16.038 -36.358)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2742",
    "data-name": "Rectangle 2742",
    width: 5.623,
    height: 24.539,
    transform: "translate(20.285 47.083)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M208.316,122.381l26.759,26.759a3.211,3.211,0,0,0,2.278.945,2.908,2.908,0,0,0,.649-.067,3.221,3.221,0,0,0,1.863-5.211.643.643,0,0,0-.067-.074l-.295-.295a.711.711,0,0,0-.073-.067L229.361,134.3l-.039-.034a5.454,5.454,0,0,1,3.128-9.458,5.529,5.529,0,0,1,2.27.261l1.615-2.686Z",
    transform: "translate(-61.889 -36.358)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M38.14,105.441H17.63a10.255,10.255,0,0,1,20.51,0",
    transform: "translate(-5.238 -28.279)",
    fill: "#dae4f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4160",
    "data-name": "Group 4160",
    transform: "translate(12.392 66.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4159",
    "data-name": "Group 4159",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    width: 20.51,
    height: 0.048,
    transform: "translate(0 10.206)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 10.109)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 10.013)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.916)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.819)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2749",
    "data-name": "Rectangle 2749",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.722)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.626)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2751",
    "data-name": "Rectangle 2751",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.529)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2752",
    "data-name": "Rectangle 2752",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.432)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2753",
    "data-name": "Rectangle 2753",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.335)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2754",
    "data-name": "Rectangle 2754",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.238)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2755",
    "data-name": "Rectangle 2755",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.141)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2756",
    "data-name": "Rectangle 2756",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 9.045)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.948)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2758",
    "data-name": "Rectangle 2758",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.851)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2759",
    "data-name": "Rectangle 2759",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.755)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2760",
    "data-name": "Rectangle 2760",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.658)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2761",
    "data-name": "Rectangle 2761",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.561)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2762",
    "data-name": "Rectangle 2762",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.464)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2763",
    "data-name": "Rectangle 2763",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.367)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2764",
    "data-name": "Rectangle 2764",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.27)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2765",
    "data-name": "Rectangle 2765",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.173)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2766",
    "data-name": "Rectangle 2766",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 8.077)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2767",
    "data-name": "Rectangle 2767",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.98)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2768",
    "data-name": "Rectangle 2768",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.883)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2769",
    "data-name": "Rectangle 2769",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.787)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2770",
    "data-name": "Rectangle 2770",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.69)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2771",
    "data-name": "Rectangle 2771",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.593)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2772",
    "data-name": "Rectangle 2772",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.496)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2773",
    "data-name": "Rectangle 2773",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.4)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2774",
    "data-name": "Rectangle 2774",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.303)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2775",
    "data-name": "Rectangle 2775",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.206)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2776",
    "data-name": "Rectangle 2776",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.109)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2777",
    "data-name": "Rectangle 2777",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 7.012)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2778",
    "data-name": "Rectangle 2778",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.915)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2779",
    "data-name": "Rectangle 2779",
    width: 20.51,
    height: 0.098,
    transform: "translate(0 6.818)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2780",
    "data-name": "Rectangle 2780",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.721)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2781",
    "data-name": "Rectangle 2781",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.624)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2782",
    "data-name": "Rectangle 2782",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.528)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2783",
    "data-name": "Rectangle 2783",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.431)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2784",
    "data-name": "Rectangle 2784",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.334)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2785",
    "data-name": "Rectangle 2785",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.237)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2786",
    "data-name": "Rectangle 2786",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.141)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2787",
    "data-name": "Rectangle 2787",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 6.044)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2788",
    "data-name": "Rectangle 2788",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.947)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2789",
    "data-name": "Rectangle 2789",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.85)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2790",
    "data-name": "Rectangle 2790",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.753)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2791",
    "data-name": "Rectangle 2791",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.656)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2792",
    "data-name": "Rectangle 2792",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.56)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2793",
    "data-name": "Rectangle 2793",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.463)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2794",
    "data-name": "Rectangle 2794",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.366)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2795",
    "data-name": "Rectangle 2795",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.269)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2796",
    "data-name": "Rectangle 2796",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.173)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2797",
    "data-name": "Rectangle 2797",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 5.076)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2798",
    "data-name": "Rectangle 2798",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.979)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2799",
    "data-name": "Rectangle 2799",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.882)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2800",
    "data-name": "Rectangle 2800",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.785)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2801",
    "data-name": "Rectangle 2801",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.688)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2802",
    "data-name": "Rectangle 2802",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.592)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2803",
    "data-name": "Rectangle 2803",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.495)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2804",
    "data-name": "Rectangle 2804",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.398)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2805",
    "data-name": "Rectangle 2805",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.302)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2806",
    "data-name": "Rectangle 2806",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.205)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2807",
    "data-name": "Rectangle 2807",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.108)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2808",
    "data-name": "Rectangle 2808",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 4.011)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2809",
    "data-name": "Rectangle 2809",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.915)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2810",
    "data-name": "Rectangle 2810",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.818)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2811",
    "data-name": "Rectangle 2811",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.721)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2812",
    "data-name": "Rectangle 2812",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.624)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2813",
    "data-name": "Rectangle 2813",
    width: 20.51,
    height: 0.097,
    transform: "translate(0 3.527)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2814",
    "data-name": "Rectangle 2814",
    width: 20.51,
    height: 3.528,
    transform: "translate(0 -0.001)",
    fill: "#dae4f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4162",
    "data-name": "Group 4162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4161",
    "data-name": "Group 4161",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M216.026,115.174a6.095,6.095,0,0,1-6.1,6.1H6.1a6.1,6.1,0,0,1,0-12.2H209.93a6.1,6.1,0,0,1,6.1,6.1",
    transform: "translate(0 -32.404)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M23.123,68.606H2.9a2.812,2.812,0,1,1,0-5.623H23.123a2.812,2.812,0,1,1,0,5.623",
    transform: "translate(-0.027 -18.712)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M54.976,68.606H43.082a2.812,2.812,0,1,1,0-5.623H54.976a2.812,2.812,0,1,1,0,5.623",
    transform: "translate(-11.964 -18.712)",
    fill: "#7e9dae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M155.755,115.025H142.877a3.851,3.851,0,0,1-3.851-3.851V71.018a3.851,3.851,0,0,1,3.851-3.851h12.878a3.852,3.852,0,0,1,3.851,3.851v40.155a3.852,3.852,0,0,1-3.851,3.851",
    transform: "translate(-41.303 -19.955)",
    fill: "#a7c6d3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4164",
    "data-name": "Group 4164",
    transform: "translate(97.723 47.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4163",
    "data-name": "Group 4163",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2816",
    "data-name": "Rectangle 2816",
    width: 20.58,
    height: 7.518,
    transform: "translate(-0.001 40.34)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2817",
    "data-name": "Rectangle 2817",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 40.133)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2818",
    "data-name": "Rectangle 2818",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 39.927)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2819",
    "data-name": "Rectangle 2819",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 39.72)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2820",
    "data-name": "Rectangle 2820",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 39.513)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2821",
    "data-name": "Rectangle 2821",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 39.306)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2822",
    "data-name": "Rectangle 2822",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 39.099)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2823",
    "data-name": "Rectangle 2823",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 38.893)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2824",
    "data-name": "Rectangle 2824",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 38.685)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2825",
    "data-name": "Rectangle 2825",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 38.479)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2826",
    "data-name": "Rectangle 2826",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 38.272)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2827",
    "data-name": "Rectangle 2827",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 38.065)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2828",
    "data-name": "Rectangle 2828",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 37.859)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2829",
    "data-name": "Rectangle 2829",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 37.651)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2830",
    "data-name": "Rectangle 2830",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 37.445)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2831",
    "data-name": "Rectangle 2831",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 37.238)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2832",
    "data-name": "Rectangle 2832",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 37.031)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2833",
    "data-name": "Rectangle 2833",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 36.825)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2834",
    "data-name": "Rectangle 2834",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 36.618)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2835",
    "data-name": "Rectangle 2835",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 36.411)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2836",
    "data-name": "Rectangle 2836",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 36.205)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2837",
    "data-name": "Rectangle 2837",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 35.998)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2838",
    "data-name": "Rectangle 2838",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 35.791)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2839",
    "data-name": "Rectangle 2839",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 35.584)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2840",
    "data-name": "Rectangle 2840",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 35.377)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2841",
    "data-name": "Rectangle 2841",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 35.171)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2842",
    "data-name": "Rectangle 2842",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 34.963)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2843",
    "data-name": "Rectangle 2843",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 34.757)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2844",
    "data-name": "Rectangle 2844",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 34.55)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2845",
    "data-name": "Rectangle 2845",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 34.343)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2846",
    "data-name": "Rectangle 2846",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 34.137)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2847",
    "data-name": "Rectangle 2847",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 33.929)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2848",
    "data-name": "Rectangle 2848",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 33.723)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2849",
    "data-name": "Rectangle 2849",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 33.517)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2850",
    "data-name": "Rectangle 2850",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 33.31)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2851",
    "data-name": "Rectangle 2851",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 33.104)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2852",
    "data-name": "Rectangle 2852",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 32.896)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2853",
    "data-name": "Rectangle 2853",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 32.69)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2854",
    "data-name": "Rectangle 2854",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 32.483)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2855",
    "data-name": "Rectangle 2855",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 32.276)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2856",
    "data-name": "Rectangle 2856",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 32.069)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2857",
    "data-name": "Rectangle 2857",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 31.862)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2858",
    "data-name": "Rectangle 2858",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 31.656)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2859",
    "data-name": "Rectangle 2859",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 31.449)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2860",
    "data-name": "Rectangle 2860",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 31.242)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2861",
    "data-name": "Rectangle 2861",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 31.035)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2862",
    "data-name": "Rectangle 2862",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 30.828)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2863",
    "data-name": "Rectangle 2863",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 30.622)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2864",
    "data-name": "Rectangle 2864",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 30.415)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2865",
    "data-name": "Rectangle 2865",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 30.208)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2866",
    "data-name": "Rectangle 2866",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 30.002)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2867",
    "data-name": "Rectangle 2867",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 29.795)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2868",
    "data-name": "Rectangle 2868",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 29.588)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2869",
    "data-name": "Rectangle 2869",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 29.382)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2870",
    "data-name": "Rectangle 2870",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 29.174)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2871",
    "data-name": "Rectangle 2871",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 28.968)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2872",
    "data-name": "Rectangle 2872",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 28.761)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2873",
    "data-name": "Rectangle 2873",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 28.554)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2874",
    "data-name": "Rectangle 2874",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 28.347)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2875",
    "data-name": "Rectangle 2875",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 28.14)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2876",
    "data-name": "Rectangle 2876",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 27.934)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2877",
    "data-name": "Rectangle 2877",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 27.727)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2878",
    "data-name": "Rectangle 2878",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 27.52)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2879",
    "data-name": "Rectangle 2879",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 27.313)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2880",
    "data-name": "Rectangle 2880",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 27.106)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2881",
    "data-name": "Rectangle 2881",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 26.9)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2882",
    "data-name": "Rectangle 2882",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 26.693)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2883",
    "data-name": "Rectangle 2883",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 26.486)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2884",
    "data-name": "Rectangle 2884",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 26.28)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2885",
    "data-name": "Rectangle 2885",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 26.073)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2886",
    "data-name": "Rectangle 2886",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 25.866)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2887",
    "data-name": "Rectangle 2887",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 25.66)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2888",
    "data-name": "Rectangle 2888",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 25.452)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2889",
    "data-name": "Rectangle 2889",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 25.246)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2890",
    "data-name": "Rectangle 2890",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 25.039)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2891",
    "data-name": "Rectangle 2891",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 24.832)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2892",
    "data-name": "Rectangle 2892",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 24.626)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2893",
    "data-name": "Rectangle 2893",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 24.418)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2894",
    "data-name": "Rectangle 2894",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 24.212)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2895",
    "data-name": "Rectangle 2895",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 24.005)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2896",
    "data-name": "Rectangle 2896",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 23.798)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2897",
    "data-name": "Rectangle 2897",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 23.591)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2898",
    "data-name": "Rectangle 2898",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 23.384)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2899",
    "data-name": "Rectangle 2899",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 23.178)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2900",
    "data-name": "Rectangle 2900",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 22.972)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2901",
    "data-name": "Rectangle 2901",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 22.765)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2902",
    "data-name": "Rectangle 2902",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 22.558)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2903",
    "data-name": "Rectangle 2903",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 22.351)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2904",
    "data-name": "Rectangle 2904",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 22.144)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2905",
    "data-name": "Rectangle 2905",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 21.938)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2906",
    "data-name": "Rectangle 2906",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 21.73)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2907",
    "data-name": "Rectangle 2907",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 21.524)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2908",
    "data-name": "Rectangle 2908",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 21.317)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2909",
    "data-name": "Rectangle 2909",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 21.11)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2910",
    "data-name": "Rectangle 2910",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 20.904)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2911",
    "data-name": "Rectangle 2911",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 20.696)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2912",
    "data-name": "Rectangle 2912",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 20.49)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2913",
    "data-name": "Rectangle 2913",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 20.283)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2914",
    "data-name": "Rectangle 2914",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 20.076)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2915",
    "data-name": "Rectangle 2915",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 19.869)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2916",
    "data-name": "Rectangle 2916",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 19.663)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2917",
    "data-name": "Rectangle 2917",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 19.457)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2918",
    "data-name": "Rectangle 2918",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 19.25)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2919",
    "data-name": "Rectangle 2919",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 19.043)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2920",
    "data-name": "Rectangle 2920",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 18.836)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2921",
    "data-name": "Rectangle 2921",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 18.629)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2922",
    "data-name": "Rectangle 2922",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 18.423)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2923",
    "data-name": "Rectangle 2923",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 18.216)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2924",
    "data-name": "Rectangle 2924",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 18.009)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2925",
    "data-name": "Rectangle 2925",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 17.802)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2926",
    "data-name": "Rectangle 2926",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 17.595)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2927",
    "data-name": "Rectangle 2927",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 17.389)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2928",
    "data-name": "Rectangle 2928",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 17.182)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2929",
    "data-name": "Rectangle 2929",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 16.975)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2930",
    "data-name": "Rectangle 2930",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 16.768)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2931",
    "data-name": "Rectangle 2931",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 16.561)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2932",
    "data-name": "Rectangle 2932",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 16.355)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2933",
    "data-name": "Rectangle 2933",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 16.149)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2934",
    "data-name": "Rectangle 2934",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 15.941)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2935",
    "data-name": "Rectangle 2935",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 15.735)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2936",
    "data-name": "Rectangle 2936",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 15.528)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2937",
    "data-name": "Rectangle 2937",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 15.321)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2938",
    "data-name": "Rectangle 2938",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 15.114)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2939",
    "data-name": "Rectangle 2939",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 14.907)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2940",
    "data-name": "Rectangle 2940",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 14.701)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2941",
    "data-name": "Rectangle 2941",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 14.494)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2942",
    "data-name": "Rectangle 2942",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 14.287)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2943",
    "data-name": "Rectangle 2943",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 14.08)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2944",
    "data-name": "Rectangle 2944",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 13.873)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2945",
    "data-name": "Rectangle 2945",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 13.667)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2946",
    "data-name": "Rectangle 2946",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 13.46)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2947",
    "data-name": "Rectangle 2947",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 13.253)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2948",
    "data-name": "Rectangle 2948",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 13.046)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2949",
    "data-name": "Rectangle 2949",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 12.839)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2950",
    "data-name": "Rectangle 2950",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 12.633)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2951",
    "data-name": "Rectangle 2951",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 12.427)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2952",
    "data-name": "Rectangle 2952",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 12.219)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2953",
    "data-name": "Rectangle 2953",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 12.013)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2954",
    "data-name": "Rectangle 2954",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 11.806)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2955",
    "data-name": "Rectangle 2955",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 11.599)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2956",
    "data-name": "Rectangle 2956",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 11.392)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2957",
    "data-name": "Rectangle 2957",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 11.185)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2958",
    "data-name": "Rectangle 2958",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 10.979)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2959",
    "data-name": "Rectangle 2959",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 10.772)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2960",
    "data-name": "Rectangle 2960",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 10.565)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2961",
    "data-name": "Rectangle 2961",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 10.358)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2962",
    "data-name": "Rectangle 2962",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 10.151)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2963",
    "data-name": "Rectangle 2963",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 9.945)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2964",
    "data-name": "Rectangle 2964",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 9.738)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2965",
    "data-name": "Rectangle 2965",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 9.531)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2966",
    "data-name": "Rectangle 2966",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 9.325)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2967",
    "data-name": "Rectangle 2967",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 9.118)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2968",
    "data-name": "Rectangle 2968",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 8.911)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2969",
    "data-name": "Rectangle 2969",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 8.705)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 8.497)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2971",
    "data-name": "Rectangle 2971",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 8.291)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2972",
    "data-name": "Rectangle 2972",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 8.084)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2973",
    "data-name": "Rectangle 2973",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 7.878)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2974",
    "data-name": "Rectangle 2974",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 7.671)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2975",
    "data-name": "Rectangle 2975",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 7.463)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2976",
    "data-name": "Rectangle 2976",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 7.257)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2977",
    "data-name": "Rectangle 2977",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 7.05)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2978",
    "data-name": "Rectangle 2978",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 6.844)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2979",
    "data-name": "Rectangle 2979",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 6.636)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2980",
    "data-name": "Rectangle 2980",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 6.43)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2981",
    "data-name": "Rectangle 2981",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 6.223)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2982",
    "data-name": "Rectangle 2982",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 6.016)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2983",
    "data-name": "Rectangle 2983",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 5.81)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2984",
    "data-name": "Rectangle 2984",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 5.603)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2985",
    "data-name": "Rectangle 2985",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 5.396)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2986",
    "data-name": "Rectangle 2986",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 5.19)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 4.983)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 4.776)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 4.569)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2990",
    "data-name": "Rectangle 2990",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 4.362)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2991",
    "data-name": "Rectangle 2991",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 4.156)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2992",
    "data-name": "Rectangle 2992",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 3.949)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2993",
    "data-name": "Rectangle 2993",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 3.742)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2994",
    "data-name": "Rectangle 2994",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 3.535)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2995",
    "data-name": "Rectangle 2995",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 3.328)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2996",
    "data-name": "Rectangle 2996",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 3.122)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2997",
    "data-name": "Rectangle 2997",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 2.914)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2998",
    "data-name": "Rectangle 2998",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 2.708)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 2.501)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3000",
    "data-name": "Rectangle 3000",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 2.295)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3001",
    "data-name": "Rectangle 3001",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 2.088)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3002",
    "data-name": "Rectangle 3002",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 1.881)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3003",
    "data-name": "Rectangle 3003",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 1.674)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3004",
    "data-name": "Rectangle 3004",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 1.468)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3005",
    "data-name": "Rectangle 3005",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 1.261)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3006",
    "data-name": "Rectangle 3006",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 1.054)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3007",
    "data-name": "Rectangle 3007",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 0.847)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3008",
    "data-name": "Rectangle 3008",
    width: 20.58,
    height: 0.207,
    transform: "translate(-0.001 0.64)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3009",
    "data-name": "Rectangle 3009",
    width: 20.58,
    height: 0.64,
    transform: "translate(0 0)",
    fill: "#a7c6d3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4172",
    "data-name": "Group 4172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4171",
    "data-name": "Mask Group 4171",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M157.917,160.406H137.549a3.851,3.851,0,0,1-3.851-3.851V136.186a3.852,3.852,0,0,1,3.851-3.851h20.368a3.852,3.852,0,0,1,3.851,3.851v20.368a3.851,3.851,0,0,1-3.851,3.851",
    transform: "translate(-39.72 -39.315)",
    fill: "#a7c6d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M159.418,148.092a9.963,9.963,0,1,1-9.964-9.963,9.964,9.964,0,0,1,9.964,9.963",
    transform: "translate(-41.441 -41.037)",
    fill: "#dae4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M157.394,149.574a6.458,6.458,0,1,1-6.458-6.458,6.458,6.458,0,0,1,6.458,6.458",
    transform: "translate(-42.923 -42.518)",
    fill: "#e36465"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4167",
    "data-name": "Group 4167",
    transform: "translate(108.966 102.577)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4166",
    "data-name": "Group 4166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4165",
    "data-name": "Group 4165",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M158.1,147.47a1.539,1.539,0,1,1-1.538-1.538,1.538,1.538,0,0,1,1.538,1.538",
    transform: "translate(-155.022 -145.932)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4170",
    "data-name": "Group 4170",
    transform: "translate(104.726 109.509)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4168",
    "data-name": "Group 4168",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M150.848,156.723a.93.93,0,1,1-.929-.929.93.93,0,0,1,.929.929",
    transform: "translate(-148.989 -155.794)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, -24)",
    filter: "url(#Path_2486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486-2",
    "data-name": "Path 2486",
    d: "M210.175,3.083,189.261,36.365a6.589,6.589,0,0,0,5.579,10.094h41.829a6.588,6.588,0,0,0,5.578-10.094L221.332,3.083a6.589,6.589,0,0,0-11.157,0",
    transform: "translate(-106.56 1.9)",
    fill: "#e36465"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M240.344,27.527a.565.565,0,0,1,.563.564V44.152a.565.565,0,0,1-.563.564h-3.353a.566.566,0,0,1-.564-.564V28.091a.566.566,0,0,1,.564-.564Zm0,19.162a.564.564,0,0,1,.563.563v3.382a.565.565,0,0,1-.563.564h-3.353a.566.566,0,0,1-.564-.564V47.252a.566.566,0,0,1,.564-.563Z",
    transform: "translate(-129.478 -35.188)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.540bf772e7ee91da36d64a4b6ef802bf.svg";
export { ForwardRef as ReactComponent };